/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.10
 */

export type ReportsFindSimilarReportsStatus =
  (typeof ReportsFindSimilarReportsStatus)[keyof typeof ReportsFindSimilarReportsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindSimilarReportsStatus = {
  publishedRRA: 'publishedRRA',
  pendingRRA: 'pendingRRA',
  draft: 'draft',
  published: 'published',
  incorrect: 'incorrect',
} as const;
